import { Configuration, ScissorsApi } from 'generated/scissors-client';

import { defaultApiClientConfiguration } from '@neptune/shared/core-apis-common-domain';

// eslint-disable-next-line no-restricted-syntax
export * from 'generated/scissors-client/apis';
// eslint-disable-next-line no-restricted-syntax
export * from 'generated/scissors-client/models';

class ScissorsAPI extends ScissorsApi {}

export const scissorsClient = new ScissorsAPI(new Configuration(defaultApiClientConfiguration));
